const translations = {
	date_from: ['da', 'from', 'von'],
	date_to: ['a', 'to', 'bis'],
	select: ['Seleziona', 'Select', 'Auswählen'],
	result_message_error: [
		"Non è stato possibile inviare la sua richiesta, verificare i dati inseriti e inviare di nuovo il modulo. Se dovesse incontrare ancora problemi, non esiti a contattarci all'indirizzo: %%ASSISTANCE_EMAIL%% segnalando l'errore riportato qui sotto:",
		'It was not possible to send your request, check the data entered and send the form again.If he still meets problems, do not hesitate to contact us at the address: %%ASSISTANCE_EMAIL%% by reporting the error below:',
		'Es war nicht möglich, Ihre Anfrage zu senden, die eingegebenen Daten zu überprüfen und das Formular erneut zu senden.Wenn er immer noch Probleme hat, zögern Sie nicht, uns unter der Adresse zu kontaktieren: %%ASSISTANCE_EMAIL%%, indem Sie den folgenden Fehler melden:',
	],
	newsletter_spam_notice: [
		'Non mandiamo spam: ogni newsletter ricevuta contiene il link per disiscriversi.',
		'We do not send spam: each newsletter received contains the link to unsubscribe.',
		'Wir senden nicht Spam: Jeder empfangene Newsletter enthält den Link zum Abbestellen.',
	],
	newsletter_subscribe: [
		'Iscrivimi anche alla newsletter di Asiago.it',
		'Also subscribe to the Asiago.it newsletter',
		'Abonnieren Sie auch den Newsletter Asiago.it',
	],
	privacy_url: [
		'https://www.asiago.it/it/privacy/',
		'https://www.asiago.it/en/privacy/',
		'https://www.asiago.it/de/privacy/',
	],
	privacy_1: ['Acconsento al', 'I consent to the', 'Ich stimme dem zu'],
	privacy_2: [
		'trattamento dei dati personali',
		'processing of personal data',
		'Verarbeitung personenbezogener Daten',
	],
	remove: ['Rimuovi', 'Remove', 'Entfernen Sie Sie'],
	add: ['Aggiungi', 'Add', 'hinzufügen'],
	prev_step: ['Indietro', 'Back', 'Rückwärts'],
	next_step: ['Continua', 'Continue', 'Mach weiter'],
	continue_info_only: [
		'Continua solo per informazioni',
		'Continue with information only',
		'Nur Informationen anfragen',
	],
	send_request: ['Invia richiesta', 'Send inquiry', 'Anfrage absenden'],
	required_fields_notice: [
		'I campi contrassegnati da un asterisco (*) sono obbligatori.',
		'The fields marked with an asterisk (*) are mandatory.',
		'Die mit einem Sternchen (*) markierten Felder sind obligatorisch.',
	],
	captcha_1: [
		'Sito protetto da Turnstile, si applicano le',
		'Site protected by Turnstile, the',
		'Site geschützt durch Turnstile, die',
	],
	captcha_2: ['norme sulla privacy', 'privacy rules', 'datenschutzregeln'],
	captcha_3: ['e i', 'and the', 'und die'],
	captcha_4: ['termini di servizio', 'terms of service', 'nutzungsbedingungen'],
	captcha_5: ['di Cloudflare.', 'of Cloudflare.', 'von Cloudflare.'],
	send_new_request: [
		'Invia una nuova richiesta',
		'Send a new request',
		'Senden Sie eine neue Anfrage',
	],
	validation_error_required: ['Campo obbligatorio', 'Required field', 'Pflichtfeld'],
	validation_error_min: [
		'Valore minimo %%VALUE%%',
		'Minimum value %%VALUE%%',
		'Mindestwert %%VALUE%%',
	],
	validation_error_max: [
		'Valore massimo %%VALUE%%',
		'Maximum value %%VALUE%%',
		'Maximalwert %%VALUE%%',
	],
	validation_error_email: [
		'Inserire un indirizzo email valido',
		'Enter a valid email address',
		'Geben sie eine gültige E-Mail-Adresse an',
	],
	validation_error_mustBeTrue: ['Campo obbligatorio', 'Required field', 'Pflichtfeld'],
	validation_error_futureDates: [
		'Seleziona un intervallo di date valido',
		'Select a valid date interval',
		'Wählen Sie ein gültiges Datumsintervall aus',
	],
	validation_error_futureDate: [
		'Seleziona una data valida',
		'Select a valid date',
		'Wählen Sie ein gültiges Datum aus',
	],
	validation_error_regex: [
		'Valore inserito non valido',
		'Inserted value not valid',
		'Eingefügter Wert nicht gültig',
	],
	mail_address_warning: [
		"Controlla bene l'indirizzo email",
		'Check the email address well',
		'Überprüfen Sie Ihre E-Mail-Adresse',
	],
	skilessontype_1: ['Lezione individuale', 'Individual lesson', 'Individuelle Lektion'],
	skilessontype_2: ['Lezione collettiva', 'Collective lesson', 'Kollektive Lektion'],
	skilessongrade_1: [
		'Livello 0: Non ho mai sciato',
		'Level 0: I have never skied',
		'Stufe 0: Ich bin noch nie Ski gefahren',
	],
	skilessongrade_2: [
		'Livello 1: Ho già provato a sciare ma con scarso risultato',
		'Level 1: I have already tried skiing but with little result',
		'Stufe 1: Ich habe bereits Skifahren versucht, aber mit wenig Erfolg',
	],
	skilessongrade_3: [
		'Livello 2: Sono uno sciatore inesperto e vorrei imparare la tecnica',
		'Level 2: I am an inexperienced skier and would like to learn the technique',
		'Level 2: Ich bin ein unerfahrener Skifahrer und möchte die Technik erlernen',
	],
	skilessongrade_4: [
		'Livello 3: Ho una discreta esperienza nello sci, ma vorrei migliorare',
		'Level 3: I have some experience in skiing, but I would like to improve',
		'Stufe 3: Ich habe etwas Erfahrung im Skifahren, möchte mich aber verbessern',
	],
	skilessongrade_5: [
		'Livello 4: Sono uno sciatore con una buona padronanza degli sci e della tecnica',
		'Level 4: I am a skier with a good command of skis and technique',
		'Level 4: Ich bin ein Skifahrer mit guten Ski- und Technikkenntnissen',
	],
	skilessontechnique_1: ['Tecnica classica', 'Classic technique', 'Klassische Technik'],
	skilessontechnique_2: ['Tecnica skating', 'Skating technique', 'Skating-Technik'],
	skilessontechnique_3: ['Entrambe le tecniche', 'Both techniques', 'Beide Techniken'],
	skilessontechnique_4: [
		'Preferisco consigliarmi con voi / Gradirei un vostro consiglio',
		'I prefer to advise you / I would appreciate your advice',
		'Ich berate Sie lieber / Ich würde mich über Ihren Rat freuen',
	],
}

export function getTranslations(langId) {
	const data = {}

	for (const [key, value] of Object.entries(translations)) {
		data[key] = value[langId - 1]
	}

	return data
}
